export default __webpack_public_path__ + "static/media/esg-57.52875ce2.jpg";